export const ROLES = {
  HR: 'HR',
  INTERVIEWER: 'interviewer',
  INTERVIEWEE: 'interviewee',
  TEMPUSER: 'tempUser',
};
